import React, { useContext, useEffect, useState } from "react";
import Visitedlist from "./Visitedlist";
import axiosPrivate from "../../api/axios";
import UserContext from "../../context/UserContext";
import VisitedListSkeleton from "../skeleton/VisitedListSkeleton";
const VisitedListContainer = ({ setBgColor }) => {
  const [visitedList, setVisitedList] = useState([]);

  const { userData } = useContext(UserContext);
  const [SkeletonLoading, setSkeletonLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosPrivate.get("/visited");
        setVisitedList(response?.data);
      } catch (error) {
        console.error(error);
      } finally {
        setSkeletonLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="home__visited-list-container">
      {/* {[...Array(8)].map((_, i) => <VisitedListSkeleton key={i} />)} */}
      {SkeletonLoading ? (
        [...Array(8)].map((_, i) => <VisitedListSkeleton key={i} />)
      ) : (
        <>
          <Visitedlist
            key="liked"
            setBgColor={setBgColor}
            data={{
              palylistname: "Liked Songs",
              playlistimage:
                "https://i1.sndcdn.com/artworks-y6qitUuZoS6y8LQo-5s2pPA-t1080x1080.jpg",
              playlistbgcolour: "rgba(80,40,240,0.5)",
            }}
            nav={"/likedsongs"}
            likedSongs={userData?.likedSongs}
          />
          {visitedList?.map((i) => (
            <Visitedlist
              key={i._id}
              setBgColor={setBgColor}
              data={i}
              nav={`/playlist/${i._id}`}
            />
          ))}
        </>
      )}
    </div>
  );
};
export default VisitedListContainer;
